import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import { type NavAnimationDirection } from 'context';

const animation = (direction: NavAnimationDirection) => {
  if (direction === 'none') return {};
  return {
    initial: { x: direction === 'forward' ? '100%' : '-100%' },
    animate: { x: 0 },
    transition: {
      duration: 0.4,
      ease: [0.25, 0.1, 0.25, 1] as const,
    },
  };
};

interface AnimatedPageProps {
  children: React.ReactNode;
  direction: NavAnimationDirection;
}

const AnimatedPage = forwardRef(
  (
    { children, direction }: AnimatedPageProps,
    ref: React.ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <motion.div ref={ref} {...animation(direction)}>
        {children}
      </motion.div>
    );
  }
);
AnimatedPage.displayName = 'AnimatedPage';

export default AnimatedPage;
